import React from "react";

const ConversionModalContext = React.createContext({});

const ConversionModalProvider = ConversionModalContext.Provider;

export { ConversionModalContext, ConversionModalProvider };
